import { createFileRoute } from "@tanstack/react-router";
import { WorkflowsPage } from "@/components/WorkflowsPage";

export const Route = createFileRoute("/_authenticated/workflows")({
  component: WorkflowsPage,
});
